import { render, staticRenderFns } from "./TemplatesBrowser.vue?vue&type=template&id=65930516&scoped=true"
import script from "./TemplatesBrowser.vue?vue&type=script&lang=js"
export * from "./TemplatesBrowser.vue?vue&type=script&lang=js"
import style0 from "./TemplatesBrowser.vue?vue&type=style&index=0&id=65930516&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65930516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65930516')) {
      api.createRecord('65930516', component.options)
    } else {
      api.reload('65930516', component.options)
    }
    module.hot.accept("./TemplatesBrowser.vue?vue&type=template&id=65930516&scoped=true", function () {
      api.rerender('65930516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplatesBrowser.vue"
export default component.exports